import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Label,
  ResponsiveContainer,
} from "recharts";
import "../SevenBarChart/SevenBarChart.css";

// Sample data
const data = [
  { date: "Mon", reports: 5000 },
  { date: "Tue", reports: 3000 },
  { date: "Wed", reports: 8000 },
  { date: "Thu", reports: 2000 },
  { date: "Fri", reports: 5500 },
  { date: "Sat", reports: 3500 },
  { date: "Sun", reports: 6000 },
];

// Custom bar shape to add border radius and shadow
const CustomBar = (props) => {
  const { fill, x, y, width, height } = props;
  const radius = 20;

  return (
    <>
      <path
        d={`M${x},${y + radius} 
           a${radius},${radius} 0 0,1 ${radius},-${radius} 
           h${width - radius * 2} 
           a${radius},${radius} 0 0,1 ${radius},${radius} 
           v${height - radius} 
           h-${width} 
           Z`}
        fill={fill}
      />
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        fill={fill}
        rx={6}
        ry={6}
      />
    </>
  );
};

const SevenBarChart = () => {
  return (
    <>
      <section className="full-section">
        <div className="full-bar-container">
          <div className="full-bar-header">
            <h1>Weekly Stock Analysis Report Counts <sub style={{color: "blue"}}>(Bar chart)</sub></h1>
          </div>

          <div className="full-bar-parent">
            <div className="full-bar-chart-container">
              <ResponsiveContainer width="100%" height={400}>
                <BarChart
                  data={data}
                  margin={{ top: 5, right: 10, left: 35, bottom: 30 }}
                >
                  {/* Gradient definition */}
                  {/* <defs>
            <linearGradient
                id="gradient"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="100%"
            >
                <stop offset="0%" stopColor="#1b4090" />
                <stop offset="100%" stopColor="#a8bdff" />
            </linearGradient>
        </defs> */}

                  <CartesianGrid
                    stroke="#d6d6d6"
                    strokeDasharray="0 0"
                    horizontal={true}
                    vertical={false}
                  />

                  {/* X-Axis with Line */}
                  <XAxis
                    dataKey="date"
                    axisLine={true} // Enabling X-Axis Line
                    tickLine={false} // Optionally, hide tick marks
                    tick={{ fontSize: "16px", fill: "#999" }} // Updated font size and color for ticks
                  >
                    <Label
                      value="Days of Week"
                      offset={-25} // Adjust this value to increase the gap
                      position="insideBottomLeft" // Left-align the label
                      textAnchor="start"
                      dx={25}
                      style={{ fontSize: "16px", fill: "#999" }} // Updated font size and color for the label
                    />
                  </XAxis>

                  {/* Y-Axis with Line */}
                  <YAxis
                    axisLine={true} // Enabling Y-Axis Line
                    tickLine={false} // Optionally, hide tick marks
                    tick={{ fontSize: "16px", fill: "#999" }} // Updated font size and color for ticks
                  >
                    <Label
                      value="Count of Reports"
                      angle={-90}
                      position="left"
                      offset={0}
                      style={{
                        textAnchor: "middle",
                        fontSize: "16px", // Updated font size
                        fill: "#999", // Updated color
                      }}
                      dx={-20} // Adds horizontal spacing (negative moves left, positive moves right)
                      dy={110} // Adds vertical spacing (negative moves up, positive moves down)
                    />
                  </YAxis>

                  <Tooltip
                    cursor={{ fill: "transparent" }}
                    labelStyle={{
                      fontSize: "16px", // Updated tooltip label font size
                      color: "#000", // Updated tooltip label color
                    }}
                    itemStyle={{
                      fontSize: "16px", // Updated tooltip item font size
                      color: "#999", // Updated tooltip item color
                    }}
                    formatter={(value) => [`${value}k`, "Reports Count"]}
                  />

                  {/* Custom Bars with Gradient Fill */}
                  <Bar
                    dataKey="reports"
                    shape={<CustomBar />}
                    fill="#5662be"
                    barSize={window.innerWidth < 600 ? 25 : 45}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
            <div className="full-bar-legend-table">
              <table>
                <thead>
                  <tr className="full-thead">
                    <td>Legend</td>
                    <td>Name</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <i
                        class="fa-solid fa-circle"
                        style={{ color: "#5662be" }}
                      ></i>
                    </td>
                    <td>Reports</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SevenBarChart;
